import { apiClient } from './client';
import type { Theme } from '@/types/login-photo';

export async function getThemes(): Promise<Theme[]> {
  const response = await apiClient.get<Theme[]>('/api/admin/themes');
  return response.data;
}

export async function getTheme(id: number): Promise<Theme> {
  const response = await apiClient.get<Theme>(`/api/admin/themes/${id}`);
  return response.data;
}

export async function createTheme(name: string): Promise<{ id: number; name: string; message: string }> {
  const response = await apiClient.post<{ id: number; name: string; message: string }>('/api/admin/themes', { name });
  return response.data;
}

export async function updateTheme(id: number, name: string): Promise<{ id: number; name: string; message: string }> {
  const response = await apiClient.put<{ id: number; name: string; message: string }>(`/api/admin/themes/${id}`, { name });
  return response.data;
}

export async function deleteTheme(id: number): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>(`/api/admin/themes/${id}`);
  return response.data;
}
